require('./assets/scss/blog.scss');
require('./assets/js/blog');
